<template>
    <div class="member-information">
        <div class="common-header-wrap">
            <!-- 兌換碼列表 -->
            <mt-header :title="$t('hunt4')" class="common-header">
                <mt-button slot="left" icon="back" @click="$router.go(-1)"></mt-button>
            </mt-header>
        </div>
        <div class="news">
            <div class="news_box" v-for="el in list" :key="el.id" @click="onGoNav(el)">
                <div class="news_box_le">
                    <img :src="el.image || require('../../../assets/image/one/hunt_duih.png')" alt="">
                </div>
                <div class="news_box_ri">   
                    <div>{{ $t('yi18') }}{{ el.phase_sn || '' }}{{ $t('yi19') }}</div>
                    <div>
                        {{ $t('hunt5') }}{{ el.exchange_code || ''}}
                    </div>
                </div>

                <div class="news_box_win">   
                    <div>{{ el.is_exchange == 0 ? $t('new9') : $t('new8') }}</div>
                </div>
            </div>
            <div class="more" v-if="(page * limit) < newsList.total"  @click="more">{{ $t('hunt6') }}</div>
        </div>
    </div>
</template>


<script>
import { MyBuyNumberList } from '../../../api/memberOne'
export default {
    name: 'HuntCashList',
    data() {
        return {
            page: 1,
            limit: 10,
            id: '',
            newsList: [],
            list: [],
        }
    },
    created(){
        
    },
    mounted(){
        const data = this.$route.query.data;
        this.id = data
        this.getNews()
    },
    methods: {
        more(){
            this.page++
            this.getNews()
        },
        goNav(name = 'HuntIndex', val){
            this.$router.push({ name: name, query: { data: val }  })
        },
        onGoNav(v){
            if( v.is_win == 1 ) this.goNav('HuntCash', v.exchange_code)
        },
        getNews(){
            const { id, page, limit  } = this
            MyBuyNumberList({
                activity_id: id,
                page, limit
            },'one').then(res=>{
                if (res && res.result) {
                    this.newsList = res.result
                    this.list.push(...res.result.data)
                }
            })
        }
    }
}
</script>


<style lang="scss" scoped>
.member-information{
    display: flex;
    flex-direction: column;
    height: 100vh;
    .news{
        overflow-y: auto;
        display: flex;
        flex: 1;
        flex-direction: column;
        padding: 17px 8px 20px;
        box-sizing: border-box;
        .news_box{
            width: 100%;
            display: flex;
            // border-bottom: 1px solid #CCCCCC;
            font-size: 16px;
            // padding-bottom: 15px;
            margin-bottom: 15px;
            background: #FFFFFF;
            border-radius: 6px;
            padding: 12px 14px;
            box-sizing: border-box;
            .news_box_le{

            }
            img{
                width: 84px;
                height: 85px;
            }
            
            .news_box_ri{
                flex: 1;
                margin-left: 20px;
                div:nth-child(1){
                    font-weight: bold;
                    color: #666;
                    font-size: 16px;
                    white-space: nowrap;   
                    overflow: hidden;        
                    text-overflow: ellipsis;
                    padding: 10px 0;
                    border-bottom: 1px solid #DFDFDF;
                }

                div:nth-child(2){
                    padding: 8px 0;
                    color: #333333;
                    font-size: 18px;
                    display: -webkit-box;           
                    -webkit-box-orient: vertical;   
                    overflow: hidden;               
                    text-overflow: ellipsis;        
                    -webkit-line-clamp: 2;          
                    line-height: 1.5;             
                }
            }

            .news_box_win{
                padding: 10px 0;
                margin-left: 10px;
                font-size: 12px;
            }
        }
    }
    .more{
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        text-align: center;
        height: 30px;
        border-radius: 20px;
        border: 1px solid #FE3421;
        font-size: 16px;
        color: #FE3421;
    }
}
</style>
